var AbstractSettingsDelegate = require("../AbstractSettingsDelegate");
var Utils = require("common/Utils");

function TOTPSettingsDelegate(menuView, enrollmentView, backupCodesView, totpTokenDialog, totpAuthDialog, logonRequestFailureHandler, keepAlivePeriod) {
    AbstractSettingsDelegate.call(this);

    const self = this;
    var currentView = menuView;
    var authPromise;

    var logonKeepAlivePeriod = keepAlivePeriod || 4.75 * 60 * 1000; // Default to every 4:45 minutes
    var unstartedLoginKeepAlive = undefined;

    menuView.addChildView(enrollmentView);
    menuView.addChildView(backupCodesView);

    function initialiseServerPath() {
        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "8.0.1")) {
            self.apiUrlEnroll = "/totp_api/actions/enroll";
            self.apiUrlBackup = "/totp_api/actions/backup_codes";
            self.apiUrlValidate = "/totp_api/actions/validate";
        } else {
            self.apiUrlEnroll = "/sslvpn_api/authentication/google/enrol";
            self.apiUrlBackup = "/sslvpn_api/authentication/google/backup_codes";
            self.apiUrlValidate = "/sslvpn_api/authentication/google/validate";
        }
    }

    function confirmInitialisedPath() {
        if (!self.apiUrlEnroll) {
            initialiseServerPath();
        }
    }

    function startLogonKeepAlive() {
        // If app is SSLVPN and version >= 8.0.1 then need to keep logon alive for TOTP, not required on older servers,
        // if app is the TOTP browser portal then logon keep alive was started by LogonHandler.
        if (App.isSSLVPNApp() && Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "8.0.1")) {
            unstartedLoginKeepAlive = setInterval(function() {
                    $.ajax({
                        type : "POST",
                        url : "/totp_api/authentication/logon",
                        data : {}
                    });
                },
                logonKeepAlivePeriod
            );
        }
    }

    $(document).on("connectionsuccessful", startLogonKeepAlive);
    $(document).on("connectionsuccessful", initialiseServerPath);
    $(document).on("initialiseServerPaths", initialiseServerPath);

    /**
     * @override
     * @inheritDoc
     */
    this.getId = function() {
        return "TOTPSettingsDelegate";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getLabel = function() {
        return $.t("common::totp.title");
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [menuView, enrollmentView, backupCodesView, totpTokenDialog, totpAuthDialog];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getTopLevelViews = function() {
        return [menuView];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setMenuEntry = function(entry) {
        $(document).on("userauthenticated", function(event, session) {
            if (session.totpEnabled) {
                entry.show();
            }
        });
        $(document).on("userunauthenticated", function() {
            entry.hide();
        });

        entry.hide();
        entry.on("click", handleMenuClick);
    };

    function changeView(view) {
        currentView = view;
        self.showView(view);
    }

    function showMenuView() {
        var session = CudaLaunch.serverConfiguration.getSession();

        if (session.totpSelfEnroll === false && session.enrolledForTOTP === false) {
            CudaLaunch.controllers.RootController.showPromptDialog($.t("common::logon.accessDenied.title"), $.t("common::totp.unableToEnroll.errorMessage"), {
                ok : $.t("common::ok.title")
            });
        } else {
            menuView.setEnrollmentState(session.totpEnabled, session.totpSelfEnroll, session.enrolledForTOTP);
            changeView(menuView);
        }
    }

    function storeCompletedAuth(params) {
        var session = CudaLaunch.serverConfiguration.getSession();

        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                if (key !== "username" && params[key] !== "") {
                    session.completedAuthSchemes[key] = params[key];
                }

                if (key === "google") {
                    session.totpAuthCompleted = true;
                }
            }
        }
    }

    this.logonToTOTP = function(params) {
        return $.ajax({
            type : "POST",
            url : "/totp_api/authentication/logon",
            data : params
        }).done(function(data) {
            if (data.result === "SUCCESS") {
                storeCompletedAuth(params);

                // Update totp values in session
                var session = CudaLaunch.serverConfiguration.getSession();
                session.enrolledForTOTP = data.enrolled;
                session.totpEnabled = data.totpAuthSchemeEnabled;
                session.totpSelfEnroll = data.canEnroll;
                session.totpKey = data.sessionKey;
                session.totpToken = data.sessionToken;

                if (unstartedLoginKeepAlive !== undefined) {
                    clearInterval(unstartedLoginKeepAlive);
                    unstartedLoginKeepAlive = undefined;
                }

                $(document).trigger("totp-authenticated");

                if (session.enrolledForTOTP) { // If already enrolled will need to provide TOTP (google) auth token
                    if (params.hasOwnProperty("google") || session.totpAuthCompleted) { // If have provided TOTP auth to the TOTP server (either just now or previously) then show the menu view
                        showMenuView();
                    } else { // If haven't provided TOTP auth, then prompt for the token now, show menu view if successfully entered
                        totpTokenDialog.promptForAttributes(function() {
                            session.totpAuthCompleted = true;
                        });
                    }
                } else {
                    showMenuView(); // If not already enrolled then show the menu view to allow enrollment (if enabled)

                    if (session.totpSelfEnroll) {
                        self.publishEvent(self.getId(), "show-enrollment-view");
                    }
                }
            } else if (data.result === "ERROR_MSG") {
                console.error("totp authentication failed. " + data.msg + ": " + data.code);
                CudaLaunch.controllers.RootController.showErrorDialog(data.msg);
            } else if (data.result === "ACCESS_DENIED") {
                var errorMsg = $.t("common::logon.accessDenied.title") + "\n" + $.t("common::logon.accessDenied.message");
                CudaLaunch.controllers.RootController.showErrorDialog(errorMsg, false, undefined, function() {
                    self.logonToTOTP({}); // Clear params and try again
                });
            } else if (data.result === "INPUT_REQUIRED") {
                var requiredAuth = data.requirements.authentication;

                if (requiredAuth) {
                    var session = CudaLaunch.serverConfiguration.getSession();
                    var schemes = requiredAuth.schemes[0];
                    var schemeName = Object.keys(schemes)[0];
                    var isTimeSensitive = schemes[schemeName].isTimeSensitive;

                    if (session && session.completedAuthSchemes[schemeName] && !isTimeSensitive) {
                        params[schemeName] = session.completedAuthSchemes[schemeName];
                        params.username = session.username;
                        self.logonToTOTP(params); // Attempt logon again
                    } else {
                        // Prompt user for the required values (scheme or challenge)
                        authPromise = totpAuthDialog.promptForAttributes(requiredAuth);
                    }
                }
            } else {
                // Something went badly wrong -- just show a generic error
                CudaLaunch.controllers.RootController.showErrorDialog($.t("common::errorPage.message"), false, undefined);
                console.error("totp authentication failed.");
            }
        }).fail(function(jqXHR) {
            logonRequestFailureHandler.handle(jqXHR);
            console.error("totp authentication failed.");
        });
    };

    function handleMenuClick() {
        var session = CudaLaunch.serverConfiguration.getSession();

        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "8.0.1")) {
            self.logonToTOTP({});
        } else {
            if (session.enrolledForTOTP) {
                if (session.completedAuthSchemes["google"]) {
                    showMenuView();
                } else {
                    totpTokenDialog.promptForAttributes(function() {
                        session.completedAuthSchemes["google"] = true;
                        showMenuView();
                    });
                }
            } else {
                showMenuView();
                self.publishEvent(self.getId(), "show-enrollment-view");
            }
        }
    }

    function isValidBackupCodes(codes) {
        if (Array.isArray(codes) && codes.length >= 0 && codes.length <= 10) {
            const validCodeRegex = /^[1-9][0-9]{7}$/;
            for (var i in codes) {
                if (codes.hasOwnProperty(i)) {
                    if (!validCodeRegex.test(codes[i])) {
                        return false;
                    }
                }
            }
            return true;
        }
        return false;
    }

    /**
     * @override
     * @inheritDoc
     */
    this.getState = function() {
        if (currentView) {
            return {
                view : currentView.getHashName()
            };
        }

        return {};
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setState = function(state) {
        if (state.view) {
            if (state.view === enrollmentView.getHashName()) {
                self.publishEvent(self.getId(), "show-enrollment-view");
            } else if (state.view === backupCodesView.getHashName()) {
                self.publishEvent(self.getId(), "show-backup-codes-view");
            } else {
                const session = CudaLaunch.serverConfiguration.getSession();
                menuView.setEnrollmentState(session.totpEnabled, session.totpSelfEnroll, session.enrolledForTOTP);
                changeView(menuView);
            }
        }
    };

    self.subscribeToChannel("Electron", "show-totp-view", handleMenuClick);
    self.subscribeToChannel("TOTPSettingsDelegate", "show-totp-view", handleMenuClick);

    self.subscribeTo("show-enrollment-view", function() {
        // Check whether already enrolled etc. and show warning prompt
        var session = CudaLaunch.serverConfiguration.getSession();
        var checkPromise;

        if (session.enrolledForTOTP) {
            checkPromise = CudaLaunch.controllers.RootController.showPromptDialog($.t("common::totp.reEnrollment.title"), $.t("common::totp.reEnrollment.message"), {
                yes : $.t("common::ok.title"),
                no : $.t("common::cancel.title")
            });
        } else {
            checkPromise = new $.Deferred().resolve("yes").promise();
        }

        confirmInitialisedPath();
        checkPromise.then(function(result) {
            if ("yes" === result) {
                $.ajax({
                    url : self.apiUrlEnroll,
                    type : "GET",
                    cache : false
                }).done(function(response) {
                    enrollmentView.setSecretKeyDetails(response.secretKey, session.username);

                    changeView(enrollmentView);
                }).fail(function() {
                    CudaLaunch.controllers.RootController.showErrorDialog($.t("common::errorPage.message"));
                });
            }
        });
    });

    self.subscribeTo("show-backup-codes-view", function() {
        confirmInitialisedPath();
        $.ajax({
            url : self.apiUrlBackup,
            type : "GET",
            cache : false
        }).done(function(response) {
            if (isValidBackupCodes(response.backupCodes)) {
                backupCodesView.setCodes(response.backupCodes);

                changeView(backupCodesView);
            } else {
                CudaLaunch.controllers.RootController.showErrorDialog($.t("common::errorPage.message"));
            }
        }).fail(function() {
            CudaLaunch.controllers.RootController.showErrorDialog($.t("common::errorPage.message"));
        });
    });

    self.subscribeTo("submit-enrollment-code", function(data) {
        confirmInitialisedPath();
        $.ajax({
            url : self.apiUrlEnroll,
            type : "POST",
            cache : false,
            data : data
        }).done(function() {
            var session = CudaLaunch.serverConfiguration.getSession();

            if (session.enrolledForTOTP) {
                self.showPreviousView();
            } else {
                session.enrolledForTOTP = true;
                session.completedAuthSchemes["google"] = true;
                showMenuView();
            }
        }).fail(function() {
            CudaLaunch.controllers.RootController.showErrorDialog($.t("common::totp.enrollment.errorMessage"));
        });
    });

    self.subscribeTo("generate-backup-codes", function() {
        confirmInitialisedPath();
        CudaLaunch.controllers.RootController.showPromptDialog($.t("common::totp.regenerateCodes.title"), $.t("common::totp.regenerateCodes.message"), {
            yes : $.t("common::ok.title"),
            no : $.t("common::cancel.title")
        }).then(function(result) {
            if ("yes" === result) {
                $.ajax({
                    url : self.apiUrlBackup,
                    type : "POST",
                    cache : false
                }).done(function(response) {
                    backupCodesView.setCodes(response.backupCodes);
                }).fail(function() {
                    CudaLaunch.controllers.RootController.showErrorDialog($.t("common::totp.backupCodes.errorMessage"));
                });
            }
        });
    });

    self.subscribeTo("post-auth-token", function(data) {
        confirmInitialisedPath();
        $.ajax({
            url : self.apiUrlValidate,
            type : "POST",
            cache : false,
            data : data.submitData
        }).done(function() {
            data.launchCallback();
            totpTokenDialog.postDone(data.deferred, data.submitData);
            showMenuView();
        }).fail(function(response) {
            if (response.status === 401) {
                totpTokenDialog.postDone(data.deferred, "failed");
            } else if (response.status === 500) {
                totpTokenDialog.postDone(data.deferred, "failed");
                CudaLaunch.controllers.RootController.showErrorDialog($.t("common::totp.validate.errorMessage"));
            } else {
                totpTokenDialog.postFailed([{
                    field : "token",
                    errorMsg : $.t("common::totp.token.errorMessage")
                }]);
            }
        });
    });

    self.subscribeTo("post-authentication-credentials", function(data) {
        totpAuthDialog.postDone(data.deferred, data.submitData);

        var params = {};

        // TODO might need some more Radius special stuff, i.e. nextToken

        if (data.submitData) {
            data.submitData.forEach(function(auth) {
                if (auth.hasOwnProperty("name") && auth.hasOwnProperty("value")) {
                    params[auth.name] = auth.value;
                }
            });
        }
        authPromise.done(function() {
            self.logonToTOTP(params);
        });
    });

    self.subscribeTo("logoff-user", function() {
        self.logoffUser();
    });

    this.logoffUser = function() {
        console.debug("logging off user from TOTP");

        $.ajax({
            url : "/totp_api/authentication/logoff",
            type : "POST"
        });
    };
}

Utils.inherits(TOTPSettingsDelegate, AbstractSettingsDelegate);

module.exports = TOTPSettingsDelegate;